import { useParams, useNavigate } from 'react-router-dom';
import { useFetch } from '../../hooks/useFetch';
import { Spinner, Empty } from '../../components';
import * as api from '../../api';

export default function ExamNatijalar() {
    const { id } = useParams();
    const nav = useNavigate();
    const { data: results, loading } = useFetch(() => api.getExamNatijalar(id), [id]);

    const maxBall = results?.[0]?.score || 1;

    return (
        <div className="page">
            <div className="page-header">
                <h1>Exam Natijalar</h1>
                <button className="btn btn-ghost" onClick={() => nav('/setter')}>← Back</button>
            </div>

            <div className="card" style={{ padding: 0 }}>
                {loading ? <Spinner /> : !results?.length ? (
                    <Empty title="Hali topshiruvlar yo‘q" message="Natijalar will appear once participants submit." />
                ) : (
                    <div className="table-wrap">
                        <table>
                            <thead>
                                <tr><th>#</th><th>Ism</th><th>Email</th><th>Ball</th><th>Topshirilgan</th></tr>
                            </thead>
                            <tbody>
                                {results.map((r) => (
                                    <tr key={r.userId} className={r.rank === 1 ? 'rank-1' : ''}>
                                        <td style={{ fontFamily: 'var(--font-mono)', color: r.rank === 1 ? 'var(--accent)' : 'var(--muted)' }}>
                                            {r.rank === 1 ? '🥇' : `#${r.rank}`}
                                        </td>
                                        <td style={{ fontWeight: 500 }}>{r.name}</td>
                                        <td style={{ color: 'var(--muted)', fontSize: 13 }}>{r.email}</td>
                                        <td>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                                <span style={{ fontFamily: 'var(--font-mono)', fontSize: 13 }}>{r.score}</span>
                                                <div className="score-bar-wrap">
                                                    <div className="score-bar" style={{ width: `${(r.score / maxBall) * 100}%` }} />
                                                </div>
                                            </div>
                                        </td>
                                        <td style={{ color: 'var(--muted)', fontSize: 13 }}>
                                            {new Date(r.submittedAt).toLocaleString()}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}